import React, {useEffect, useState} from 'react'
import {Box, Text} from "grommet";
import {TokensTable, TokensTableItem} from "./TokensTable";
import {useAccount, useBalance} from "wagmi";
import {useTokenPrice} from "../../providers/PriceProvider";
import {ERC20Tokens, NativeToken} from "../../tokens";
import {getBalance} from "../../api/erc20";
import {CurrencyAmount} from "@uniswap/sdk-core";

export const Dashboard = () => {
  const { address: userAddress, isConnected } = useAccount()
  // @ts-ignore
  const { harmony: harmonyPrice, tokensMap, tokensCount } = useTokenPrice()

  const {
    data: nativeTokenBalance,
    isFetching: isNativeTokenFetching
  } = useBalance({
    address: userAddress,
    enabled: userAddress && isConnected
  })

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [tokenBalances, setTokenBalances] = useState<TokensTableItem[]>([])

  useEffect(() => {
    if(userAddress) {
      if(tokensCount > 0) {
        setTokenBalances((currentItems) => {
          return currentItems.map(item => {
            const symbol = item.token.symbol
            let price = tokensMap[symbol?.toLowerCase() as string]
            if(!price) {
              if(symbol === 'WONE') {
                price = harmonyPrice
              }
            }
            return {
              ...item,
              price: price || null
            }
          })
        })
      }
    } else {
      setTokenBalances([])
    }
  }, [isLoading, userAddress, tokensMap, tokensCount, harmonyPrice]);

  useEffect(() => {
    const loadData = async () => {
      if(userAddress) {
        setIsLoading(true)
        try {
          const items: TokensTableItem[] = []
          await Promise.all(ERC20Tokens.map(async (token) => {
            const balance = await getBalance(token.address, userAddress)
            const amount = CurrencyAmount.fromRawAmount(token, balance.toString())
            if(amount.greaterThan(0)) {
              const symbol = token.symbol
              let price = tokensMap[symbol?.toLowerCase() as string]
              if(!price) {
                if(symbol === 'WONE') {
                  price = harmonyPrice
                } else if(symbol?.toLowerCase().includes('usdt')) {
                  price = 1
                }
              }
              items.push({
                token,
                amount: (+amount.toExact()).toFixed(2),
                tokenPrice: price || null
              })
            }
          }))
          setTokenBalances(items)
        } catch (e) {
          console.error('Failed to load balance:', e)
        } finally {
          setIsLoading(false)
        }
      }
    }
    loadData()
  }, [userAddress]);

  const oneBalanceFormatted = nativeTokenBalance && harmonyPrice
    ? (+nativeTokenBalance.formatted).toFixed(2)
    : '0'

  const oneTokenData: TokensTableItem = {
    token: NativeToken,
    amount: oneBalanceFormatted,
    tokenPrice: harmonyPrice
  }

  const tokensList = nativeTokenBalance
    ? [oneTokenData, ...tokenBalances]
    : [...tokenBalances]

  const totalUsdAmount = tokensList.reduce((acc, item) => {
    if(item.tokenPrice) {
      acc += +item.amount * item.tokenPrice
    }
    return acc
  }, 0)

  return <Box pad={'52px 32px'} width={'100%'}>
    <Box>
      <Text size={'42px'}>Dashboard</Text>
    </Box>
    <Box margin={{ top: '32px' }}>
      <Box gap={'8px'}>
        <Text size={'24px'}>All accounts</Text>
        <Text size={'38px'} weight={'bold'}>${totalUsdAmount.toFixed(2)}</Text>
      </Box>
    </Box>
    <Box margin={{ top: '32px' }} width={'95%'} style={{ maxWidth: '1300px' }}>
      <TokensTable
        data={tokensList}
        walletAddress={userAddress}
      />
    </Box>
  </Box>
}
